"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const base_1 = require("../base");
const constant_1 = require("../constant");
class MarketModule extends base_1.TectonicSDKModule {
    async getSupportedAssets(ifSkipTonicMarket) {
        if (this.assets.length) {
            return this.assets;
        }
        let tokenStatesInWorld;
        if (ifSkipTonicMarket) {
            tokenStatesInWorld = lodash_1.default.filter(this.world, (e) => e.contractType === "FaucetToken" ||
                e.contractType === "EIP20Interface");
        }
        else {
            tokenStatesInWorld = lodash_1.default.filter(this.world, (e) => e.contractType === "FaucetToken" ||
                e.contractType === "EIP20Interface" ||
                e.contractType === "Tonic");
        }
        this.assets = await Promise.all(tokenStatesInWorld.map(async (tokenState) => {
            const underlyingTokenContract = this.getContractByName(tokenState.contractName);
            const underlyingTokenSymbol = await underlyingTokenContract.symbol();
            const underlyingTokenName = await underlyingTokenContract.name();
            const underlyingTokenDecimals = await underlyingTokenContract.decimals();
            const tTokenContract = this.getContractByName(`tToken_${tokenState.contractName}`);
            const tTokenDecimals = await tTokenContract.decimals();
            return {
                type: "token",
                underlyingAddress: underlyingTokenContract.address,
                name: underlyingTokenName,
                symbol: underlyingTokenSymbol,
                decimals: underlyingTokenDecimals,
                tTokenAddress: tTokenContract.address,
                tTokenDecimals,
            };
        }));
        const tEtherContract = this.getContractByName("TEther");
        this.assets.push({
            type: "ether",
            underlyingAddress: constant_1.TectonicConst.ETHER_ADDRESS,
            tTokenAddress: tEtherContract.address,
            name: "Crypto.com Coin",
            symbol: "CRO",
            decimals: 18,
            tTokenDecimals: await tEtherContract.decimals(),
        });
        return this.assets;
    }
}
exports.default = MarketModule;
//# sourceMappingURL=market.js.map